import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { MeterType, meterTypeToLabel } from 'src/app/shared/model/technical/MeterType';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'digires-meter-entry-list',
  templateUrl: './meter-entry-list.component.html',
  styleUrls: ['./meter-entry-list.component.scss']
})
export class MeterEntryListComponent implements OnChanges, OnDestroy {
  readonly destroy$: Subject<boolean> = new Subject<boolean>();

  readonly allTypeOfMeterOptions: MeterType[] = Object.values(MeterType);

  @Input() disabled: boolean;
  @Input() formGroup: FormArray;
  lastSub: Subscription;
  meterEntries: {fg: FormGroup}[] = [];

  ngOnChanges(changes: SimpleChanges) {
    this.meterEntries = Object.values(this.formGroup.controls).map(fg => {return {fg: fg as FormGroup};});
    if (this.lastSub) {
      this.lastSub.unsubscribe();
    }
    this.lastSub = this.formGroup
      .valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        const currentFgs = Object.values(this.formGroup.controls);
        if (this.meterEntries.length !== this.formGroup.length // length is different
          || this.meterEntries.some(e => !currentFgs.includes(e.fg)) // old entry no longer in fg
        ) {
          this.meterEntries = currentFgs.map(fg => {return {fg: fg as FormGroup};});
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  typeOfMeterOptionToLabel(meterOption: MeterType): string {
    return meterTypeToLabel[meterOption];
  }

  onAddEntry() {
    const fg = new FormGroup({
      id: new FormControl(),
      ref: new FormControl(),
      type: new FormControl(),
    });
    this.formGroup.push(fg);
  }

  onRemoveEntry(entry: {fg: FormGroup}) {
    const idx = this.findIndexOf(entry.fg);
    if (idx >= 0) {
      this.formGroup.removeAt(idx);
    }
  }

  private findIndexOf(fg: FormGroup) {
    for (let i = 0; i < this.formGroup.length; i++) {
      if (this.formGroup.at(i) === fg) {
        return i;
      }
    }
    return -1;
  }

}
